import React, { Component, PropTypes } from 'react'
import styles from './AddRewardModal.css'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import NumberInputWithFeedback from '../../NumberInputWithFeedback'

const popover = <Popover className={`${styles.popover}`} id='popover'>
    If enabled, member will get X%<br />
    discount with specified<br />
    maximum value
  </Popover>
class PercentageTypeInput extends Component {

  render () {
    return (
      <div>
        <div className='row bottom5' style={{paddingTop: '20px'}}>
          <div className='col-md-12'>
            <div style={{fontSize: '18px'}} className={`${styles['title']} bottom10`}>Redeem Points (Y)</div>
          </div>
        </div>
        <div className='row bottom20'>
          <div className='col-md-12'>
            <NumberInputWithFeedback
              inputValue={this.props.point}
              onChangeValue={this.props.onChangePoint}
              suffix=' Points'
              placeholder='0 Points'
              thousandSeparator='.'
              decimalPrecision={0}
              decimalSeparator=','
              errorMessage={this.props.pointInputError}
            />
          </div>
        </div>

        <div className='row bottom5'>
          <div className='col-md-12'>
            <div style={{fontSize: '18px'}} className={`${styles['title']} bottom10`}>Discount Percentage on Total Sale (X%)</div>
          </div>
        </div>
        <div className='row bottom10'>
          <div className='col-md-12'>
            <NumberInputWithFeedback
              inputValue={this.props.discount}
              onChangeValue={this.props.onChangeDiscount}
              suffix='%'
              placeholder='0%'
              thousandSeparator='.'
              decimalPrecision={0}
              decimalSeparator=','
              errorMessage={this.props.discountInputError}
            />
          </div>
        </div>

        <div className='row bottom5' style={{paddingTop: '20px'}}>
          <div className='col-md-12'>
            <div style={{fontSize: '18px'}} className={`${styles['title']}`}>Rewards Rule</div>
          </div>
        </div>
        <div className='row bottom20'>
          <div className='col-md-12'>
            <div className='checkbox maximum-discount'>
              <label>
                <input
                  type='checkbox'
                  checked={this.props.isMaximumDiscountEnabled}
                  onChange={this.props.onChangeMaximumDiscountCheckbox}
                />
                Set maximum discount value
                <OverlayTrigger placement='top' overlay={popover}>
                  <img className={`${styles['tooltip-image']}`} src={require('assets/images/info-tooltip.png')} />
                </OverlayTrigger>
              </label>
            </div>
          </div>
          <div className='col-md-12'>
            <NumberInputWithFeedback
              inputValue={this.props.maximumDiscount}
              onChangeValue={this.props.onChangeMaximumDiscount}
              prefix='Rp. '
              placeholder='Rp. 0'
              thousandSeparator='.'
              decimalPrecision={0}
              decimalSeparator=','
              errorMessage={this.props.maximumDiscountInputError}
              disabled={!this.props.isMaximumDiscountEnabled}
            />
          </div>
        </div>
      </div>
    )
  }
}

PercentageTypeInput.propTypes = {
  point: PropTypes.string.isRequired,
  onChangePoint: PropTypes.func.isRequired,
  pointInputError: PropTypes.string.isRequired,
  isMaximumDiscountEnabled: PropTypes.bool.isRequired,
  onChangeMaximumDiscountCheckbox: PropTypes.func.isRequired,
  maximumDiscount: PropTypes.string.isRequired,
  onChangeMaximumDiscount: PropTypes.func.isRequired,
  maximumDiscountInputError: PropTypes.string.isRequired
}

export default PercentageTypeInput



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/Reward/AddRewardModal/PercentageTypeInput.js